import { PropsWithChildren } from 'react';
import { Label } from '@/Domain/components/Shared/Label/Label';

type Props = {
  title: string;
  description: string;
};

export const ActionBox = ({ title, description, children }: PropsWithChildren<Props>) => (
  <div className="border border-border rounded-2xl p-6">
    <div className="w-full grid grid-cols-[1fr_auto] gap-x-20 items-center">
      <div>
        <Label className="mb-1">{title}</Label>
        <p className="text-sm text-foreground-subtle">{description}</p>
      </div>
      {children}
    </div>
  </div>
);
